import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

// Import des styles
import "./index.css";

// Import des pages
import Landing from "./pages/Landing/Landing";
import About from "./pages/About/About";
import JoinUs from "./pages/JoinUs/JoinUs";
import Members from "./pages/Members/Members";
import MemberCard from "./pages/MemberCard/MemberCard";
import Regulations from "./pages/Regulations/Regulations";
import Legal from "./pages/Legal/Legal";
import Error404 from "./pages/Error404/Error404";
import SignUp from "./pages/SignUp/SignUp";
import Login from "./pages/Login/Login";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import ResetThePassword from "./pages/ResetThePassword/ResetThePassword";
import Dashboard from "./pages/Dashboard/Dashboard";
import DashboardAdmin from "./pages/Dashboard/DashboardAdmin";

//___________________________________________________
// Composant protégeant les routes privées
function ProtectedRoute({ children }) {
  const token = sessionStorage.getItem("token");

  if (!token) {
    return <Navigate to="/Login" replace />;
  }

  return children;
}

//___________________________________________________
// Création des routes
function App() {
  return (
    <Router>
      <Routes>
        {/* Pages publiques */}
        <Route path="/" element={<Landing />} />
        <Route path="/About" element={<About />} />
        <Route path="/JoinUs" element={<JoinUs />} />
        <Route path="/Members" element={<Members />} />
        <Route path="/Members/:id" element={<MemberCard />} />
        <Route path="/Regulations" element={<Regulations />} />
        <Route path="/Legal" element={<Legal />} />
        <Route path="/SignUp" element={<SignUp />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/ResetPassword" element={<ResetPassword />} />
        <Route
          path="/ResetPassword/:resetToken"
          element={<ResetThePassword />}
        />

        {/* Pages protégées */}
        <Route
          path="/Dashboard/*"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/DashboardAdmin/*"
          element={
            <ProtectedRoute>
              <DashboardAdmin />
            </ProtectedRoute>
          }
        />

        {/* 404 */}
        <Route path="*" element={<Error404 />} />
      </Routes>
    </Router>
  );
}

// Export de l'application
export default App;
